import { ReactNode } from 'react';

import { Box, LinearProgress } from '@material-ui/core';

type FormProps = {
  loading?: boolean;
  children: ReactNode;
  onSubmit: () => void;
};

export default function DialogForm({ onSubmit, loading, children }: FormProps) {
  return (
    <Box component="form" onSubmit={onSubmit}>
      {children}
      {loading && <LinearProgress color="primary" />}
    </Box>
  );
}
